import PolicyDiffTreeDirective from './components/policy-diff-directive/';
import PolicyDiffTreeSection from './components/policy-diff-section-directive/';
import PolicyDiffTreeNode from './components/policy-diff-node-directive/';
import PolicyDiffService from './services/PolicyDiffService';

export default angular.module('edge.policydiff.app', [])
    .factory('PolicyDiffService', PolicyDiffService)
    .directive('gwPolicyDiffTreeDirective', PolicyDiffTreeDirective)
    .directive('gwPolicyDiffTreeSection', PolicyDiffTreeSection)
    .directive('gwPolicyDiffNode', PolicyDiffTreeNode);